<script>
  import _ from 'lodash';
  import {onMount, onDestroy} from 'svelte';

  export let style = '';
  export let length = 4;
  export let onComplete;

  let input = '';

  const keydown = e => {
    if (e.key === 'Backspace') {
      backspace();
      return;
    }
    if (!/^\d$/.test(e.key)) return;

    // HACK: last key is entered into message form
    e.preventDefault();

    onPressButton(e.key);
  };

  onMount(() => {
    window.addEventListener('keydown', keydown);
  });

  onDestroy(() => {
    window.removeEventListener('keydown', keydown);
  });

  const onPressButton = number => {
    input += number;

    if (input.length >= length) {
      onComplete && onComplete(input);
      input = '';
    }
  };

  const backspace = () => {
    input = input.substr(0, input.length - 1);
  };
</script>


<column class="passcode-input" style={style}>
  <row expand center class="input-area">
<!--    dummy for padding -->
    <div></div>
      {#each _.range(length) as i}
        <ion-icon name="ellipse" class="input-indicator" class:active={input.length > i}></ion-icon>
      {/each}
    <div></div>
  </row>

  <column expand>
      {#each _.range(3) as i}
        <row expand>
            {#each _.range(3) as j}
              <button class="expand" type="button" on:click={() => onPressButton(i * 3 + j + 1)}>{i * 3 + j + 1}</button>
            {/each}
        </row>
      {/each}
    <row expand>
      <expand></expand>
      <button class="expand" type="button" on:click={() => onPressButton(0)}>0</button>
      <button class="expand" type="button"><ion-icon name="backspace-outline" on:click={backspace}></ion-icon></button>
    </row>
  </column>
</column>


<style>
  .input-area {
    background-color: #efefef;
    justify-content: space-between;
  }

  .input-indicator {
    font-size: 1.2rem;
    color: #ccc;
  }

  .input-indicator.active {
    color: black;
  }

  button {
    align-self: stretch;
    font-size: 1.2rem;
    padding: 0;
    border: none;
  }
</style>